const TRIAL_NAME_MAP: Record<string, string> = {
  DARATU: "DARATU-ALZ",
};

export function cleanTrialName(name: string): string {
  const cleaned = name
    .replace(/\s+Demo\s+Trial/gi, "")
    .replace(/\s*\(Phase\s+\d[\d/]*\)\s*$/i, "")
    .trim();
  return TRIAL_NAME_MAP[cleaned] ?? cleaned;
}

export const normalizeFillValue = (v: unknown) => {
  if (typeof v === "boolean") return v ? "True" : "False";
  return v;
};

export const removeUnderscores = (value: string) => {
  if (!value) return "";
  return value.replace(/_/g, " ");
};

export const normalizeString = (string: string) => {
  if (!string) return "";
  string = "" + string;
  return string
    ?.toLowerCase()
    .trim()
    .replace(/[^a-zA-Z0-9]/g, "_");
};

export const normalizedIncludes = (string1: string, string2: string) => {
  return normalizeString(string1).includes(normalizeString(string2));
};
